import { connect } from 'react-redux';
import Component from './component';

import setContactFromRouteAction from '../../actions/contacts/setfromroute';
import selectContactAction from '../../actions/contacts/select';
import resetDocumentsAction from '../../actions/documents/reset';
import resetDashboardAction from '../../actions/dashboard/reset';
import resetSaltusOwnerAction from '../../actions/saltusowners/reset';
import resetDashboardAssetAllocationAction from '../../actions/dashboardassetallocations/reset';
import resetDashboardValueOverTimeAction from '../../actions/dashboardvalueovertime/reset';
import resetPerformanceForDashboardAction from '../../actions/dashboardperformance/reset';
import resetNotificationsAction from '../../actions/notifications/reset';
import resetAccountTypeAction from '../../actions/accounttype/reset';
import getDocumentsForContactAction from '../../actions/documents/get';
import resetContactIDRouteAction from '../../actions/contacts/resetfromroute';

const mapStateToProps = (state) => ({
  session: state.session.get('data'),
  contactidroute: state.contacts.get('contactidroute'),
  contacts: state.contacts.get('list'),
  contact: state.contacts.get('set'),
  gettingdata: state.contacts.get('gettingdata'),
});
const mapDispatchToProps = (dispatch) => ({
  handleGetContactIDRouteAction: async (ContactID) => {
    await dispatch(await setContactFromRouteAction(ContactID));
  },
  selectContact: async (contact) => {
    await dispatch(await resetAccountTypeAction());
    await dispatch(await selectContactAction(contact));
    await dispatch(await resetDashboardAction());
    await dispatch(await resetSaltusOwnerAction());
    await dispatch(await resetDashboardAssetAllocationAction());
    await dispatch(await resetDashboardValueOverTimeAction());
    await dispatch(await resetPerformanceForDashboardAction());
    await dispatch(await resetNotificationsAction());
    await dispatch(await resetDocumentsAction());
    await dispatch(await getDocumentsForContactAction());
    await dispatch(await resetContactIDRouteAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
